var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bar",style:(_vm.style),on:{"click":function($event){$event.preventDefault();return _vm.$emit('clicked')}}})}
var staticRenderFns = []

export { render, staticRenderFns }